<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5 18C3.34315 18 2 16.6569 2 15V7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V15C22 16.6569 20.6569 18 19 18H15C15.5523 18 16 18.4477 16 19C16 19.5523 15.5523 20 15 20H9C8.44772 20 8 19.5523 8 19C8 18.4477 8.44772 18 9 18H5ZM19 6H5C4.44772 6 4 6.44772 4 7V15C4 15.5523 4.44772 16 5 16H19C19.5523 16 20 15.5523 20 15V7C20 6.44772 19.5523 6 19 6Z"
    fill="currentColor"
  />
</svg>
